export default __webpack_public_path__ + "static/logo-dark-5d9e5210fb8248d5d727f7676af0d9aa.svg";